/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// redux
import {useSelector} from 'react-redux';
// material
import {Group, DateRangePickerDropDown, ListSelectDropDown} from '@insticator/insticator-ui';

// utils
import {countries} from '@insticator/insticator-ui'; // iui-utils
import {transpileDataForFilters} from '../../../../../../utils/transpilers/transpileDataForFilters';
import {getSiteAndAppFilterName} from "../../../../../../utils/filterhelpers";

// styles
import injectSheet from 'react-jss';
import styles from './disabledglobalfilter_styles';



/* ========== ~~~~~~~~~~ DISABLED GLOBAL APPLICATION FILTERS ~~~~~~~~~~ ========== *
  This is a group of presentational components to show what values are selected from global filter */

export default injectSheet(styles)((props) => {

    // redux state
    const sidebarOpen = useSelector(state => state.app.sidebarOpen)
    const sitesAndApps = useSelector((state) => state.account.sitesAndApps)
    const selectedDateRange = useSelector((state) => state.app.filters.dateRange)
    const selectedComparisonType = useSelector((state) => state.app.filters.compareTo)
    const selectedDevices = useSelector((state) => state.app.filters.devices)
    const selectedCountries = useSelector((state) => state.app.filters.countries)
    const selectedSites = useSelector((state) => state.app.filters.sites)
    const selectedSitesByType = useSelector((state) => state.app.filters.sitesByType)


    return (
        <div id="globalfilter" className={`${props.classes.globalFilter} sidebarOpen-${sidebarOpen}`}>
            <Group name={'filters'}>
                <ListSelectDropDown
                    klass={`filter-site`}
                    name={getSiteAndAppFilterName(sitesAndApps)}
                    // icon={`link`}
                    items={[]}
                    selected={selectedSites.length ? selectedSitesByType : null}
                    noEmptyApply={true}
                    buttonAction={() => {}}
                    disabled={true}
                />
                <ListSelectDropDown
                    klass={`filter-device`}
                    name={selectedDevices.length === 1 ? 'Device' : 'Devices'}
                    // icon={`mobile-alt`}
                    items={[
                        {value: 'DESKTOP', name: 'Desktop', selected: selectedDevices.indexOf('DESKTOP') >= 0},
                        {value: 'MOBILE', name: 'Mobile Web', selected: selectedDevices.indexOf('MOBILE') >= 0}
                    ]}
                    noEmptyApply={true}
                    buttonAction={() => {}}
                    disabled={true}
                />
                <ListSelectDropDown
                    klass={`filter-country`}
                    name={selectedCountries.length === 1 ? 'Country' : 'Countries'}
                    // icon={`globe`}
                    items={transpileDataForFilters(countries, false, true)}
                    // undefined creates correct structure for ListSelectDropDown
                    selected={selectedCountries.length ? {undefined: selectedCountries} : null}
                    noEmptyApply={true}
                    buttonAction={() => {}}
                    disabled={true}
                />
            </Group>
            <DateRangePickerDropDown
                klass={`filter-date`}
                indicatorTitle={'Date range'}
                hideButtons={false}
                showShortcuts={true}
                showShortcutTextInPreview={true}
                customDateRanges={false}
                use4PMLogic={true}
                range={selectedDateRange}
                updateRange={() => {}}
                compareType={selectedComparisonType}
                changeCompareType={() => {}}
                handleApply={() => {}}
                disabledDays={[]}
            />
        </div>
    );
});
